import { IReturnOfferCaptions } from './types';

export const getContent = (): IReturnOfferCaptions => {
    return {
        title: 'subscription.cancellation.returnOffer.renewNow.title',
        subTitle: 'subscription.cancellation.returnOffer.renewNow.subtitle',
        extraText: 'subscription.discountOffer.disclaimerNew',
        firstBadgeText: 'subscription.cancellation.returnOffer.firstBadge',
        secondBadgeText: 'subscription.cancellation.specialOffer.withDynamicPercent.secondBadge',
        submitButton: 'subscription.discountOffer.button.changePlan',
    };
};
